import moment from "moment";
import Exported from "../service/endpoints";
import request from "../service";
import { Images } from "../assets";
import VideoComponent from "../component/VideoComponent";
import { ContentState, convertFromHTML, convertToRaw } from "draft-js";

export const getTimeRange = (dateTime) => {
    const timeRange = moment.utc(dateTime).format('h:mm A');
    return timeRange
}

export const getDateFormat = (date) => {
    const dateRange = moment.utc(date);
    return dateRange
}

export const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getUserTimeZone = () => {
    const now = new Date();
    const offsetMinutes = now.getTimezoneOffset();
    const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
    const offsetMins = Math.abs(offsetMinutes) % 60;

    const sign = offsetMinutes <= 0 ? '+' : '-';
    const formattedOffset = `${sign}${String(offsetHours).padStart(2, '0')}:${String(offsetMins).padStart(2, '0')}`;

    return formattedOffset;
}

export const UserRoleID = {
    "Admin": "1",
    "Retailer": "2",
    "Mechanic": "3",
    "AuthorizedUser": "4",
}

let requestData = {
    url: Exported.Endpoints.countryCode,
    method: Exported.APIMethods.GET,
}
export const getCountryCode = () => {

    return new Promise((resolve, reject) => {
        request(requestData)
            .then(res => {
                resolve(res?.data?.data)
            }).catch(err => {
                reject(err)
            })
    })
}

let subDropdown = {
    url: Exported.Endpoints.subCategoryDropdown,
    method: Exported.APIMethods.GET,
}

export const subCategoryDropdown = () => {
    return new Promise((resolve, reject) => (
        request(subDropdown).then((res) => {
            resolve(res?.data?.data)
        }).catch((err) => {
            reject(err)
        })

    ))
}

let appId = {
    url: Exported.Endpoints.applicationId,
    method: Exported.APIMethods.GET,
}

export const applicationDropdown = () => {
    return new Promise((resolve, reject) => (
        request(appId).then((res) => {
            resolve(res?.data?.data)
        }).catch((err) => {
            reject(err)
        })

    ))
}

export const singleUpload = async (uploadedFiles) => {
    const formData = new FormData();
    formData.append('file', uploadedFiles[0])
    let obj = {}
    await request({
        url: Exported.Endpoints.singleUpload,
        method: Exported.APIMethods.POST,
        data: formData,
        headers: {
            'content-type': 'multipart/form-data',
        },
    }).then((res) => {
        console.log(res)
        if (res?.data?.status) {
            obj['mimetype'] = res?.data?.data?.mimetype
            obj['url'] = res?.data?.data?.url
        }
    }).catch((err) => {
        console.log(err)
    })
    return obj
}

export const YESOrNoOption = {
    "1": "Yes",
    "2": "No",
}

export const ContactOption = {
    "1": "Phone",
    "2": "Email",
    "3": "WhatsApp ",
}

export const CountryCode = {
  "1": "India",
  "2": "UAE",
  "3": "Saudi",
  "4": "Jordan",
  "5": "Zambia",
  "6": "Nigeria",
  "7": "Kenya",
  "8": "Tanzania",
  "9": "USA",
  "10": "Uganda",
  "11": "Oman",
  "12": "Bahrain",
  "13": "Qatar",
  "14": "Iraq",
  "100": "All"
};


export const StatusCode = {
    "1": "Open",
    "2": "In Progress",
    "3": "Closed",
}

export const StatusColor = {
    "1": "#FC0000",
    "2": "#CE8704",
    "3": "#01CB46",
}

export const ActiveStatus = {
    true: "Active",
    false: "Inactive"
}
export const ActiveStatusColor = {
    true: "#01CB46",
    false: "#FC0000"
}

export const Filters = 'filters'
export const TRUCK_SOLUTIONS = 'truck_solutions'
export const BEARINGS = 'bearings'
export const BULK_FILTRATION = 'bulk_filtration'

export const KG_FILTERS = 'KG Filters'
export const KG_TRUCK_SOLUTIONS = 'KG Truck Solutions'
export const KG_BEARINGS = 'KG Bearings'
export const KG_BULK_FILTRATION = 'KG Bulk Filtration'
export const KG_PROMO = 'KG Promo'
export const KG_SKF = 'KG SKF'
export const KG_GREASE = 'KG Grease'

export const imageFormat = ['.jpg', '.jpeg', '.png', '.svg']
export const videoFormat = ['.mp4', '.avi', '.mkv', '.mov', '.wmv', '.flv']
export const fileFormat = ['.pdf', '.docx', '.xlsx', '.txt', '.csv']
export const getFileType = (fileName) => {
    const extension = '.' + fileName?.split('.').pop().toLowerCase();
    return extension;
}
// export const getFormat = (fileName) => {
//     const extension = '.' + fileName?.split('.').pop().toLowerCase();
//     if (imageFormat?.includes(extension)) {
//         return Images.imageFormat
//     } else if (videoFormat?.includes(extension)) {
//         return Images.videoFormat
//     } else {
//         if (extension === 'pdf') {
//         }
//         return Images.pdfFormat
//     }
// }

export const getFormat = (fileName) => {
    const isFormatMatch = (format, extension) => {
        if (Array.isArray(format)) {
            return format.includes(extension);
        } else {
            return format === extension;
        }
    };

    const getExtension = (file) => {
        return "." + file?.split(".").pop().toLowerCase();
    };

    if (Array.isArray(fileName)) {
        return fileName.map((file) => {
            const extension = getExtension(file);

            if (isFormatMatch(imageFormat, extension)) {
                return Images.imageFormat;
            } else if (isFormatMatch(videoFormat, extension)) {
                return Images.videoFormat;
            } else if (isFormatMatch(fileFormat, extension)) {
                return Images.pdfFormat;
            }
            return null;
        });
    }

    if (typeof fileName === "string") {
        const extension = getExtension(fileName);
        if (isFormatMatch(imageFormat, extension)) {
            return Images.imageFormat;
        } else if (isFormatMatch(videoFormat, extension)) {
            return Images.videoFormat;
        } else if (isFormatMatch(fileFormat, extension)) {
            if (extension === ".xlsx") {
                return Images.excelFomrat;
            } else {
                return Images.pdfFormat;
            }
        }
        return null;
    }

    return null;
};

export const convertHTMLToDraft = (html) => {
    const blocksFromHTML = convertFromHTML(html);
    const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
    );
    const rawContent = convertToRaw(contentState);
    return JSON.stringify(rawContent);
};

const openRedirectDocs = (url) => {
    window.open(url, '_blank')
}

export const displayFileType = (fileName) => {
    return (
        videoFormat?.includes(getFileType(fileName)) ?
            <VideoComponent src={fileName} /> :
            fileFormat?.includes(getFileType(fileName)) ?
                <div style={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }} title={fileName} onClick={() => openRedirectDocs(fileName)}>
                    <img src={getFormat(fileName)} style={{ height: '100px' }} />
                    <div style={{ width: '140px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} >{fileName}</div>
                </div>
                :
                imageFormat?.includes(getFileType(fileName)) ?
                    <img src={fileName} alt={'Product'} /> : null
    )
}